<template>
  <div>
    <div class="tip">
      <el-popover placement="top" width="190" trigger="hover">
            <div class="list">
              <!-- <span @click="gotip3" ><img class="img" src="../assets/tip-icon1.png" />发工资条向导</span > -->
              <!-- <span @click="gotip2"><img class="img" src="../assets/tip-icon2.png" />使用指南</span > -->
                <a
              target="view_window"
              href="http://wpa.qq.com/msgrd?v=3&uin=3179561760&site=qq&menu=yes"
              style="display: block"
              ><span><img src="../assets/tip-icon3.png" />联系客服QQ</span></a
            >
            <span style="position: relative" class="payroll_wx_Father"
              ><img src="../assets/wx.png" />
              <img class="payroll_wx" src="../assets/inquire_payroll_wx.jpg" />
              联系客服微信</span
            >
            <span style="position: relative" class="payroll_wx_Father"
              ><img src="../assets/workvx.png" />
              <img class="payroll_wx" src="../assets/workvxkf.jpg" />
              联系客服企业微信</span
            >
          </div>
         <div @click="hideSilde" class="otherapp" slot="reference">
          <i class="el-icon-service w20"></i><span v-if="isShowSilde">在线咨询</span>
         </div>
       </el-popover>
    </div>
    <el-dialog
      @close="closeDialog"
      title="使用方法"
      :visible.sync="isMovieShow"
      style="margin-top: -10vh"
      :close-on-click-modal="false"
    >
      <video
        ref="video"
        style="width: 100%; height: 75vh; background: #fff"
        src="../assets/video.mp4"
        autoplay
        controls="controls"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      value1: 0,
      isMovieShow: false,
      isShowSilde:false
    }
  },
  methods: {
    closeDialog() {
      console.log('stop')
      this.$refs.video.pause()
    },
    hideSilde(){
      this.isShowSilde=!this.isShowSilde;
    },
    showTip() {
      if (this.$store.state.smstipFlag) {
        this.$store.state.smstipFlag = false
      } else {
        this.$store.state.smstipFlag = true
      }
    },
    gotip3() {
      window.localStorage.setItem('isIntorShow', false)
      this.value1 = 0
      this.isMovieShow = true
      this.$refs.video.play()
      this.$refs.video.currentTime = 0
    },
    gotip2() {
      this.$router.push('/helpcenterindex/help')
    },
    hideTipList: function (event) {
      let sp = document.getElementById('tipList')
      if (sp) {
        if (!sp.contains(event.target)) {
          this.isShow = false
        }
      }
    },
  },
}
</script>
<style scoped lang="less">
.tip {
  position: fixed;
  bottom: 5vh;
  right: 0px;
  font-size: 40px;
  height:46px;
  z-index: 1200;}
 
  .list {
    width: 165px;
    font-size: 14px;
    color: #555;
    background: #fff;
    border-radius: 8px;
    // display: none;
    .close {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  span {
    line-height: 46px;
    display: block;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #666;
   padding-left:5px;
    img {
      width: 25px;
      padding-right: 5px;
    }
  }
  .list span:hover {
    background: rgba(230,34,41,0.17);
    color: #e62229;
  }
.payroll_wx_Father:hover {
  .payroll_wx {
    display: block;
  }
}
.payroll_wx {
  position: absolute;
  width: 200px !important;
  left: -210px;
  bottom: 0;
  display: none;
}
.tipList {
  width: 160px;
  height: 46px;
  background: #3bc492;
  box-shadow: 0px 8px 16px 0px rgba(59, 196, 146, 0.15);
  border-radius: 28px 0px 0px 28px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.otherapp{
  display: flex;
  background: #e62229;
  color:#fff;
  padding: 0px 15px 0 25px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  height:46px;
  span{
    color:#fff;
    font-size:20px;
  }
  }
  .w20::before{font-size:22px;position: relative;
    top: -4px;}
</style>